<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 123.351 49.922">
    <g id="Coupe" transform="translate(10739.469 823.21)">
      <path id="Path_87066" data-name="Path 87066"
        d="M42.923,54.525A10.078,10.078,0,1,0,53,64.6a10.088,10.088,0,0,0-10.08-10.08m-.017,17.78h-.011a7.723,7.723,0,1,1,.011,0"
        transform="translate(-10678.541 -847.97)" :fill="themeColor" />
      <path id="Path_87067" data-name="Path 87067"
        d="M17.572,54.525A10.078,10.078,0,1,0,27.649,64.6a10.09,10.09,0,0,0-10.077-10.08m0,17.78a7.712,7.712,0,1,1,7.712-7.712,7.726,7.726,0,0,1-7.712,7.712"
        transform="translate(-10725.605 -847.97)" :fill="themeColor" />
      <path id="Path_87068" data-name="Path 87068"
        d="M39.381,62.664l57.066.386c1.628.437,3.225.8,4.741,1.074A45.41,45.41,0,0,1,114.5,68.3c3.807,2.656,5.935,11.1,6.555,15.213a1.174,1.174,0,0,0,2.305-.414c-.069-.46-1.922-12.713-7.258-16.561a43.825,43.825,0,0,0-14.27-4.676,58.017,58.017,0,0,1-9.206-2.465c-1.814-.791-4.113-1.931-6.944-3.345a144.368,144.368,0,0,0-17.846-7.963C60.972,45.041,52.952,44.1,45.674,44.1a101.341,101.341,0,0,0-15.5,1.265l-.6.094a1.181,1.181,0,0,0-.666.317L18.573,55.626l-12.9,1.628a1.18,1.18,0,0,0-.983.837L.065,74.072a1.2,1.2,0,0,0,0,.666c1.779,6.027,5.321,9.774,9.24,9.774h4.579a1.108,1.108,0,0,0,.865-.326,1.173,1.173,0,0,0-.791-2.019H9.313c-2.6,0-5.247-2.885-6.752-7.346l-.143-.426,4.31-14.9,12.516-1.58a1.18,1.18,0,0,0,.66-.314L30.25,47.746l2.176-.257c6.649-.831,22.211-2.776,34.5,2.762a143.862,143.862,0,0,1,17.163,7.632l5.2,2.725-49.917-.291a1.174,1.174,0,0,0,.009,2.348"
        transform="translate(-10739.486 -867.314)" :fill="themeColor" />
      <path id="Path_87069" data-name="Path 87069"
        d="M54.73,59.78a1.158,1.158,0,0,0,1.225-1.151,1.145,1.145,0,0,0-.328-.837,1.165,1.165,0,0,0-.811-.36h-36.8a1.183,1.183,0,0,0-.84.326,1.176,1.176,0,0,0,.791,2.022Z"
        transform="translate(-10708.309 -842.574)" :fill="themeColor" />
    </g>
  </svg>

</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
